import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useArchivesStore = defineCollectionStore({
	id: 'archives',
	endpoint: '/api/archives/sites',
	dataKey: 'sites',
	mapKey: 'map',
	dataFallback: [],
	mapFallback: {},
	trackLastFetched: true,
	// Verbatim quirk (copy/paste from the sites store originally).
	errorLabel: 'Fetch Sites Error: ',
	fetchName: 'fetchArchives',
	getters: {
		sitesData(state: any) {
			return state.sites;
		},
		sitesMap(state: any) {
			return state.map;
		},
	},
	byId: {
		actionName: 'fetchArchivedSiteById',
		endpoint: (id) => `/api/archives/sites/${id}`,
	},
});
